import React, { useState } from "react";
import "../assets/css/profile.css"; // You'll create this file
import Footer from "../components/Restaurant/Footer"; // Your restaurant-specific mobile footer

function Profile() {
  const [activeProfileTab, setActiveProfileTab] = useState("restaurantProfile"); // State for tabs
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // State for mobile sidebar

  // State for form fields (only basic ones for demonstration)
  const [restaurantName, setRestaurantName] = useState("Vendor Ade Restaurant");
  const [contactName, setContactName] = useState("Ade Vendor");
  const [contactPhone, setContactPhone] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [instagramHandle, setInstagramHandle] = useState("");
  const [state, setState] = useState("Lagos");
  const [lga, setLga] = useState("Ikeja");
  const [pickupAddress, setPickupAddress] = useState(
    "3 Koleosho Street, Ikeja, Lagos"
  );
  const [averageReadyTime, setAverageReadyTime] = useState("15");
  const [openTime, setOpenTime] = useState("9:00 AM");
  const [closeTime, setCloseTime] = useState("9:00 PM");
  const [description, setDescription] = useState("");
  const [agreeTerms, setAgreeTerms] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleProfileSubmit = (e) => {
    e.preventDefault();
    console.log("Profile data submitted:", {
      restaurantName,
      contactName,
      contactPhone,
      contactEmail,
      instagramHandle,
      state,
      lga,
      pickupAddress,
      averageReadyTime,
      openTime,
      closeTime,
      description,
    });
    // Add API call to update profile here
  };

  const handleKitchenEvaluationSubmit = (e) => {
    e.preventDefault();
    if (agreeTerms) {
      console.log("Kitchen Evaluation submitted, terms agreed.");
      // Add API call for kitchen evaluation submission
    } else {
      alert("You must agree to the terms and conditions.");
    }
  };

  return (
    <div className="profile-layout">
      {/* Sidebar - Reused from Dashboard/Delivery/Menu */}
      <aside className={`dashboard-sidebar ${isSidebarOpen ? "open" : ""}`}>
        <nav className="sidebar-nav">
          <ul>
            <li className="nav-item">
              <a href="#my-restaurants" className="nav-link">
                <i className="icon-restaurant"></i>
                My Restaurant(s)
              </a>
            </li>
            <li className="nav-item">
              <a href="#dashboard" className="nav-link">
                <i className="icon-dashboard"></i>
                Dashboard
              </a>
            </li>
            {/* <li className="nav-item">
              <a href="#my-delivery" className="nav-link">
                <i className="icon-delivery"></i>
                My Delivery
              </a>
            </li> */}
            <li className="nav-item">
              <a href="#my-menu" className="nav-link">
                <i className="icon-menu"></i>
                My Item
              </a>
            </li>
            <li className="nav-item active">
              {" "}
              {/* Active for My Profile */}
              <a href="#my-profile" className="nav-link">
                <i className="icon-profile"></i>
                My Profile
              </a>
            </li>
          </ul>
          <ul className="sidebar-bottom-nav">
            <li className="nav-item">
              <a href="#support" className="nav-link">
                <i className="icon-support"></i>
                Support
              </a>
            </li>
            <li className="nav-item sign-out">
              <a href="#sign-out" className="nav-link">
                <i className="icon-signout"></i>
                Sign Out
              </a>
            </li>
          </ul>
        </nav>
      </aside>

      {/* Overlay for when sidebar is open on mobile */}
      {isSidebarOpen && (
        <div className="sidebar-overlay visible" onClick={toggleSidebar}></div>
      )}

      {/* Main Content */}
      <main className="profile-main-content">
        <div className="profile-header">
          {/* Hamburger menu for mobile to open the sidebar */}
          <div className="hamburger-menu" onClick={toggleSidebar}>
            &#9776;
          </div>
          <h1 className="profile-title">My Profile</h1>
        </div>

        {/* Hero Image / Banner */}
        <div className="profile-banner">
          {/* Replace with your actual banner image */}
          <img src="path/to/restaurant-banner.jpg" alt="Restaurant Banner" />
        </div>

        {/* Profile Tabs */}
        <section className="profile-tabs-section">
          <div className="profile-tabs">
            <button
              className={`tab-button ${
                activeProfileTab === "restaurantProfile" ? "active" : ""
              }`}
              onClick={() => setActiveProfileTab("restaurantProfile")}
            >
              Restaurant Profile
            </button>
            <button
              className={`tab-button ${
                activeProfileTab === "kitchenEvaluation" ? "active" : ""
              }`}
              onClick={() => setActiveProfileTab("kitchenEvaluation")}
            >
              Kitchen Evaluation
            </button>
          </div>

          <div className="profile-tab-content">
            {activeProfileTab === "restaurantProfile" && (
              <form
                onSubmit={handleProfileSubmit}
                className="restaurant-profile-form"
              >
                <h2>Restaurant basic information</h2>
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="restaurantName">
                      * Name (as to be displayed)
                    </label>
                    <input
                      type="text"
                      id="restaurantName"
                      value={restaurantName}
                      onChange={(e) => setRestaurantName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="contactName">Contact</label>
                    <input
                      type="text"
                      id="contactName"
                      value={contactName}
                      onChange={(e) => setContactName(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="contactPhone">* Contact phone</label>
                    <input
                      type="tel"
                      id="contactPhone"
                      value={contactPhone}
                      onChange={(e) => setContactPhone(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="contactEmail">* Contact Email</label>
                    <input
                      type="email"
                      id="contactEmail"
                      value={contactEmail}
                      onChange={(e) => setContactEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group full-width">
                    <label htmlFor="instagramHandle">Instagram Handle</label>
                    <input
                      type="text"
                      id="instagramHandle"
                      value={instagramHandle}
                      onChange={(e) => setInstagramHandle(e.target.value)}
                    />
                  </div>
                </div>

                <h2>Restaurant location</h2>
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="state">* State</label>
                    <select
                      id="state"
                      value={state}
                      onChange={(e) => setState(e.target.value)}
                      required
                    >
                      <option value="">Select State</option>
                      <option value="Lagos">Lagos</option>
                      {/* Add more states */}
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="lga">* Local Area</label>
                    <select
                      id="lga"
                      value={lga}
                      onChange={(e) => setLga(e.target.value)}
                      required
                    >
                      <option value="">Select Local Area</option>
                      <option value="Ikeja">Ikeja</option>
                      {/* Add more LGAs based on selected state */}
                    </select>
                  </div>
                  <div className="form-group full-width">
                    <label htmlFor="pickupAddress">* Pickup address</label>
                    <input
                      type="text"
                      id="pickupAddress"
                      value={pickupAddress}
                      onChange={(e) => setPickupAddress(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <h2>Restaurant cooking time</h2>
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="averageReadyTime">
                      * Average ready time
                    </label>
                    <input
                      type="number"
          inputMode="numeric"
                      id="averageReadyTime"
                      value={averageReadyTime}
                      onChange={(e) => setAverageReadyTime(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    {/* Placeholder for alignment */}
                  </div>
                  <div className="form-group">
                    <label htmlFor="openTime">* Open time</label>
                    <input
                      type="time"
                      id="openTime"
                      value={openTime}
                      onChange={(e) => setOpenTime(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="closeTime">* Close time</label>
                    <input
                      type="time"
                      id="closeTime"
                      value={closeTime}
                      onChange={(e) => setCloseTime(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="form-group full-width">
                  <label htmlFor="description">Description</label>
                  <textarea
                    id="description"
                    rows="4"
                    placeholder="Enter description here..."
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  ></textarea>
                </div>

                <button type="submit" className="update-profile-button">
                  Update Profile
                </button>
              </form>
            )}

            {activeProfileTab === "kitchenEvaluation" && (
              <form
                onSubmit={handleKitchenEvaluationSubmit}
                className="kitchen-evaluation-form"
              >
                <h2>Kitchen Evaluation Page</h2>
                <p>
                  Thank you for providing your restaurant profile. We aim to
                  satisfy our customers, thus we run a check on your restaurant
                  and kitchen. Please read below and click agree to submit your
                  profile:
                </p>
                <ul className="evaluation-list">
                  <li>We have a cooking area and have uploaded pictures.</li>
                  <li>
                    We have storage facilities to preserve foods - Fridge and
                    Freezer.
                  </li>
                  <li>
                    We have the required staff to deliver within our cooking
                    time.
                  </li>
                  <li>
                    We keep our restaurant clean and follow proper hygiene
                    practices.
                  </li>
                  <li>Our email is active and will track all notifications.</li>
                </ul>

                <h3>Note the following important pickup practices:</h3>
                <ul className="pickup-practices-list">
                  <li>
                    You MUST click "Restaurant open" button to start each day.
                  </li>
                  <li>
                    You MUST click "Restaurant close" button to close each day.
                  </li>
                  <li>You MUST use a seal tape to seal the food pack.</li>
                  <li>
                    You MUST paste the order code sticker on the order package.
                  </li>
                </ul>

                <div className="terms-checkbox">
                  <input
                    type="checkbox"
                    id="agreeTerms"
                    checked={agreeTerms}
                    onChange={(e) => setAgreeTerms(e.target.checked)}
                  />
                  <label htmlFor="agreeTerms">
                    I agree to the terms and conditions.
                  </label>
                </div>

                <button
                  type="submit"
                  className="submit-evaluation-button"
                  disabled={!agreeTerms}
                >
                  Submit
                </button>
              </form>
            )}
          </div>
        </section>
      </main>

      {/* Mobile Bottom Footer */}
      <Footer />
    </div>
  );
}

export default Profile;
